import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import AboutPreview from '../components/AboutPreview';
import ServicesPreview from '../components/ServicesPreview';
import StatsSection from '../components/StatsSection';
import WhyCABPreview from '../components/WhyCABPreview';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustBar />
      <AboutPreview />
      <StatsSection />
      <ServicesPreview />
      <WhyCABPreview />
      <TestimonialsSection />
      <CTASection />
    </main>
  );
}
